/*
 *  Featured Collection
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2019/11/18
 */

import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-featured-brands]';
export const CAROUSEL_SELECTOR = '[data-brands-carousel]';

export class FeaturedBrands extends CarouselSection {
  constructor(container) {
    super(container);


    
    // carousel
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.slick = this.initCarousel(this.carouselContainer);

    this.reSlick(ResponsiveSizes.large, this.carouselContainer);
  }

  optionOverrides() {
    return {
      infinite: this.carouselContainer.data('infinite') == false ? false : true,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 3,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 3,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      speed: this.carouselContainer.data('slide-speed') || 500,
      dots: this.carouselContainer.data('dots') == false ? false : true,
      arrows: false,
      adaptiveHeight: this.carouselContainer.data('adaptiveheight') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      variableWidth: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 4, slidesToScroll: 4 , infinite: true }
        },
        {
          breakpoint: 849,
          settings: "unslick"
        }
      ]
    }
  }

}

register(CONTAINER_SELECTOR, FeaturedBrands);